import React__default from 'react';
import { Card, MediaQuery } from '@grandvisionhq/common';

const OrderListItemCard = ({ header , imagePath , labels , href , onClick , subtitle  })=>{
    const { useIsPhone  } = MediaQuery;
    const isPhone = useIsPhone();
    return /*#__PURE__*/ React__default.createElement(Card, {
        layout: isPhone ? 'vertical' : 'horizontal',
        href: href,
        onClick: onClick,
        "aria-label": labels.viewDetails,
        className: "order-list-item-card"
    }, /*#__PURE__*/ React__default.createElement(Card.Image, {
        backgroundColor: "var(--color--shade-lightest)",
        alt: header,
        src: imagePath,
        className: "order-list-item-card__image"
    }), /*#__PURE__*/ React__default.createElement(Card.Content, {
        center: true,
        variant: "link"
    }, /*#__PURE__*/ React__default.createElement(Card.Heading, null, header), subtitle ? /*#__PURE__*/ React__default.createElement(Card.Text, {
        variant: "caption",
        color: "text-secondary"
    }, subtitle) : null));
};
var OrderListItemCard$1 = OrderListItemCard;

export { OrderListItemCard$1 as default };
//# sourceMappingURL=OrderListItemCard.js.map
